import styled from "styled-components";

export const LoginWithPhoneWrapper = styled.div``;